import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

import {
  SidebarInfoSection,
  SidebarInfoSectionText,
  ReservationRulesAndTermsLinks,
  View,
} from 'components'

export const SaunaReservations: React.FC = () => {
  const { t } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const saunaConfig = moduleConfig.sauna
  const saunaFallbackLinks: { href: string; label: string }[] = []
  if (saunaConfig?.contractDocumentLink) {
    saunaFallbackLinks.push({
      href: saunaConfig.contractDocumentLink,
      label: t('reservations:modal.saunaRulesLink'),
    })
  }
  if (saunaConfig?.termsOfUseDocumentLink) {
    saunaFallbackLinks.push({
      href: saunaConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  return (
    <TitleController
      title={t('titles:saunaReservations', 'Sauna reservations')}
    >
      <View allowOverflow>
        <View.Header className="desktop:h-80">
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>
          <View.HeaderTitle className="phone:text-common-gray-7">
            {t('reservations:pageTitleSauna')}
          </View.HeaderTitle>
        </View.Header>

        <View.Sidebar>
          <SidebarInfoSection className="space-y-4">
            <SidebarInfoSectionText>
              {t(
                'reservations:saunaSidebarDescription',
                'Täällä voit tarkastella saunavuoroja ja varata oman saunavuoron valitsemalla vapaan ajan tai painamalla Varaa'
              )}
            </SidebarInfoSectionText>
            <ReservationRulesAndTermsLinks
              contractId={currentContractId}
              reservableCategory="house_sauna"
              realPropertyHierarchyId={null}
              fallbackLinks={saunaFallbackLinks}
            />
            <ReservationsList reservableCategory="house_sauna" />
          </SidebarInfoSection>
        </View.Sidebar>

        <View.Content>
          <ReservationCalendars reservableCategory="house_sauna" />
        </View.Content>
      </View>
    </TitleController>
  )
}
